import { OnInit, Output, EventEmitter, Input } from '@angular/core'

export class DepartmentBase implements OnInit {
  /** 
   * Codigos de municipios para marcados
  */
  @Input() set codes(_codes: any) {
    for (let i = 0; i < _codes.length; i++) {
      let element = document.getElementById('_'+parseInt(_codes[i]))

      if(element){
        element.classList.add("selected")
      }
    }
  }
  /**
   * Salida de codigo de municipio seleccionado
   */
  @Output() municipalityCode = new EventEmitter
  municipalities = []
  ngOnInit(): void {
    let $description = document.querySelector(".description");
    document.querySelectorAll('.cls-1').forEach(item => {
      item.addEventListener('click', (event: any) => {
        //handle click
        document.querySelectorAll('.cls-1').forEach(item => {
          item.classList.remove("active")
        })
        event.target.classList.add("active")
        this.municipalityCode.emit(event.target.dataset.name)
      })

      item.addEventListener('mouseenter', (event: any) => {
        $description.classList.add('active');
        $description.innerHTML = this.municipalities.find(el => el.code.includes(event.target.dataset.name)).name
      });

      item.addEventListener('mouseleave', e => {
        $description.classList.remove('active');
      });

    })
  }
}